export const LocationType = {
  EMPLOYEE: 'EMPLOYEE',
  CONTAINER: 'CONTAINER'
};
